<template lang="pug">
a.inline-flex.justify-evenly.items-center(:href="geoObj.internal ? '' : `https://ip.skk.moe/query?q=${porps.ip}`" target="_blank") {{ porps.ip }}
  div.rounded-sm.ml-1.gap-x-1(:class="geoStringClass" v-if="isValidIP")
    span {{ $utils.geoStr(geoObj) }}
    slot(name="geoStringAppend")
</template>

<script lang="ts" setup>
const ipGeo = useIPGeo()
const $utils = useUtils()
const porps = defineProps<{
  ip?: string
  geoStringClass?: string | string[] | { [key: string]: string }
  geoStringFontSize?: string | number
  // ipGeo: Object
}>()
onMounted(() => ipGeo.addIP(porps.ip))
watch(() => porps.ip, () => ipGeo.addIP(porps.ip))
const geoObj = computed(() => ipGeo.getLocalGeoInfo(porps.ip))
const isValidIP = computed(() => ipGeo.isValidIP(porps.ip || ''))
</script>

<style lang='postcss' scoped>
a {
  color: inherit;
}
</style>
